import { useMemo } from 'react';

import { useAppSelector } from '../../store/store';
import type { Ir } from '../porta';
import { STATUS_META, billingLabel, fmtBRL, fmtDate, usePaymentHistory } from '../../hooks/usePaymentHistory';

// O HISTÓRICO DE PAGAMENTOS (/pagamentos), sem tela. Cópia literal de `pages/Payments`: a lista do
// núcleo (assinatura e perfis avulsos), e o resumo que só soma o que foi PAGO (somar cancelada ou
// vencida diria que saiu um dinheiro que nunca saiu).

export const usePagamentos = ({ ir: navigate }: { ir: Ir }) => {
  const user = useAppSelector((state) => state.auth.user);
  const { items, loading, falhou, tentarDeNovo } = usePaymentHistory(user?.id);

  const resumo = useMemo(() => {
    const pagos = items.filter((item) => item.status === 'paid');
    return {
      total: pagos.reduce((soma, item) => soma + item.amount, 0),
      quantidade: items.length,
      ultimo: pagos[0]?.date ?? null,
    };
  }, [items]);

  return {
    carregando: loading,
    falhou: !loading && falhou,
    tentarDeNovo,
    vazio: !loading && !falhou && !items.length,
    resumo: {
      total: fmtBRL(resumo.total),
      quantidade: String(resumo.quantidade),
      rotuloDaQuantidade: resumo.quantidade === 1 ? 'Cobrança' : 'Cobranças',
      ultimo: fmtDate(resumo.ultimo),
    },
    itens: items.map((item) => ({
      id: item.id,
      tipo: item.kind,
      titulo: item.title,
      data: fmtDate(item.date),
      forma: billingLabel(item.billing) ?? '—',
      status: STATUS_META[item.status].label,
      tom: STATUS_META[item.status].tone,
      valor: fmtBRL(item.amount),
    })),
    verPlanos: () => navigate('/planos'),
  };
};

export type DadosDosPagamentos = ReturnType<typeof usePagamentos>;
